var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0877 12.5857H13.2068C16.2293 12.4882 18.6127 10.0182 18.6235 6.97406C18.6235 3.87573 16.0993 1.35156 13.001 1.35156C9.90267 1.35156 7.3785 3.87573 7.3785 6.97406C7.3785 10.0182 9.751 12.4882 12.8927 12.5857C12.9577 12.5749 13.0335 12.5749 13.0877 12.5857ZM9.0035 6.97406C9.0035 4.7749 10.8018 2.97656 13.001 2.97656C15.2002 2.97656 16.9985 4.7749 16.9985 6.97406C16.9877 9.11906 15.3193 10.8632 13.196 10.9607C13.0552 10.9499 12.9035 10.9499 12.8493 10.9607C10.6935 10.8849 9.0035 9.14073 9.0035 6.97406Z",
    fill: "#14477D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31354 22.8016C8.92771 23.8849 11.0619 24.4266 13.1852 24.4266C15.3085 24.4266 17.4319 23.8849 19.0569 22.8016C20.5627 21.7941 21.386 20.4182 21.386 18.9341C21.386 17.4499 20.5519 16.0849 19.0569 15.0882C15.8285 12.9324 10.5635 12.9324 7.31354 15.0882C5.80771 16.0957 4.98438 17.4716 4.98438 18.9557C4.98438 20.4399 5.80771 21.8049 7.31354 22.8016ZM6.60938 18.9666C6.60938 18.0349 7.17271 17.1466 8.21271 16.4532C10.9102 14.6549 15.4602 14.6549 18.1577 16.4532C19.1869 17.1357 19.761 18.0241 19.761 18.9449C19.761 19.8766 19.1977 20.7649 18.1577 21.4582C15.4602 23.2674 10.9102 23.2674 8.21271 21.4582C7.18354 20.7757 6.60938 19.8874 6.60938 18.9666Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.6ab0d6536bfb08567360958dc082532f.svg";
export { ForwardRef as ReactComponent };